





import { Component, Vue } from "vue-property-decorator";
// import { Action, Getter, Mutation } from "vuex-class";
// import HelloWorld from "@/components/HelloWorld.vue";

@Component({
  // components: {
  //   HelloWorld,
  // }
})
export default class extends Vue {}
